import './Appheader.css';

function Appheader(){

    return (
    <header className='app_header'>
    <img className='logopict' src="/images/tahpnaras.jpg" />
    </header>
    );
}

export default Appheader;